export default "__VITE_ASSET__q_feWvNj__"